(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sections-faq"] && !Shopify.designMode) return;
  try {
    

  $('button.question').click(function() {
    var handle = $(this).attr('data');
    $('.answer-'+handle).slideToggle(150);
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme_footer"]) return;
  try {
    

  // subnavigation
  $('footer nav button').click(function() {

    // display child menu
    var handle = $(this).attr('data');
    $('footer .ul-' + handle).slideToggle(150);

    // animate button "plus" icon
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme_header"]) return;
  try {
    

  // display header search
  $('.microsearch').click(function() {
    $('.header_search').toggleClass('active');
    $('.header_search input').focus();
  });

  // hide header search
  $('.header_search button.close').click(function() {
    $('.header_search').removeClass('active');
    $('.header_search input').val('');
  });

  // display desktop sub navigation
  $('nav.desktop button').click(function() {
    $(this).toggleClass('active');
    var handle = $(this).attr('data');
    $('.ul-desktop-' + handle).slideToggle(150);
  });

  // display mobile menu
  $('.navicon button').click(function() {

    $('header nav.mobile').toggleClass('active');
  });

  // subnavigation
  $('header nav.mobile button').click(function() {

    // display child menu
    var handle = $(this).attr('data');
    $('header .ul-' + handle).slideToggle(150);

    // animate button "plus" icon
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme_header_knitcollage"]) return;
  try {
    

  // display header search
  $('.microsearch').click(function() {
    $('.header_search').toggleClass('active');
    $('.header_search input').focus();
  });

  // hide header search
  $('.header_search button.close').click(function() {
    $('.header_search').removeClass('active');
    $('.header_search input').val('');
  });

  // hide desktop sub navigation on escape
  $(document).on('keydown', function(event) {
    if (event.key == "Escape") {
      $('.subnav').slideUp(150);
      $('nav.desktop button').removeClass('active');
    }
  });

  // hide desktop sub navigation on outclick
  $(document).on("click", function(event){
    if(
      !$(event.target).closest('.subnav').length && 
      !$(event.target).is('nav.desktop button')
    ) {
      $('.subnav').slideUp(150);
      $('nav.desktop button').removeClass('active');

    // display desktop sub navigation
    } else if( $(event.target).is('nav.desktop button') ) {

      var handle = $(event.target).attr('data');
      $('.subnav').each(function() {
        var status = $(this).css('display');
        var active = $(this).attr('class').indexOf(handle);
        var local_handle = $(this).attr('data');        

        if(status !== 'none' && active == -1) {
          $(this).slideToggle(150);
          $('button.button-' + local_handle).toggleClass('active');
        }
      });
      $('.subnav-' + handle).slideToggle(150);
      $('button.button-' + handle).toggleClass('active');
    }
  });

  // display mobile menu
  $('.navicon button').click(function() {
    $('header nav.mobile').toggleClass('active');
    $('.gray_background').toggleClass('active');
  });

  // hide mobile menu
  $('.gray_background button').click(function() {
    $('header nav.mobile').removeClass('active');
    $('.gray_background').removeClass('active');
  });

  // subnavigation
  $('header nav.mobile button.parent').click(function() {
    // display child menu
    var handle = $(this).attr('data');
    $('header .ul-' + handle).slideToggle(150);
    // animate button "plus" icon
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();
})();
